import axios from "axios";
import moment from "moment";

export const formatDateTimeLocal = (isoOrDateString) => {
	if (!isoOrDateString) return "";
	const momentObject = moment(isoOrDateString);
	return momentObject.isValid() ? momentObject.format("DD/MM/YYYY HH:mm") : "";
};

export const formatDateLocal = (isoOrDateString) => {
	if (!isoOrDateString) return "";
	const momentObject = moment(isoOrDateString);
	return momentObject.isValid() ? momentObject.format("DD/MM/YYYY") : "";
};

export const formatTimeLocal = (isoOrDateString) => {
	if (!isoOrDateString) return "";
	const momentObject = moment(isoOrDateString);
	return momentObject.isValid() ? momentObject.format("HH:mm") : "";
};

export const formatarData = (data) => {
	return moment(data, "DD-MM-YYYY HH:mm")
		.locale("pt-br")
		.format("ddd, DD [de] MMMM [às] HH:mm");
};

export const addZeroEsquerda = (num, size = 2) => String(num).padStart(size, "0");

export const transformarMinutosEmHoras = (minutos) => {
	let horas = Math.floor(minutos / 60);
	let minutosRestantes = minutos % 60;
	return `${addZeroEsquerda(horas)}:${addZeroEsquerda(minutosRestantes)}:00`;
};

export const limparMoeda = (valor) => {
	valor = valor?.replace("R$", "");
	valor = valor?.replaceAll(".", "");
	valor = valor?.replace(",", ".");
	valor = valor?.replace("/^p{Z}+|p{Z}+$/u", "");
	valor = valor?.trim();
	return valor;
};

export const formatBRL = (value) => {
	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		minimumFractionDigits: 2,
	});
	return formatter.format(value);
};

export const formatDecimal = (value) => {
	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "decimal",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return formatter.format(value);
};

export const formatTelefone = (value) => {
	if (!value) return "";
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");
	return value;
};

export const formatCpfCnpj = (value) => {
	if (!value) return "";
	const numbers = value.toString().replace(/\D/g, "");
	if (numbers.length === 11) {
		return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
	}
	if (numbers.length === 14) {
		return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
	}
	return numbers;
};

export const formatarNome = (nome) => {
	if (!nome || typeof nome !== "string" || nome.trim() === "") return "";
	const parte = nome.trim().split(/\s+/);
	if (parte.length === 1) return parte[0];
	const primeiroNome = parte[0];
	const segundoNome = parte[1];
	const segundaInicial = segundoNome.charAt(0).toUpperCase() + ".";
	return `${primeiroNome} ${segundaInicial}`;
};

export const formatHourInput = (input) => {
	let value = input.target.value.replace(/\D/g, "");
	let formattedValue = "";

	if (value.length > 0) {
		if (parseInt(value[0]) > 2) {
			value = "";
		} else if (value.length >= 2) {
			const hour = parseInt(value.substring(0, 2));
			if (hour > 23) value = value[0];
		}
	}

	if (value.length > 2) {
		if (parseInt(value[2]) > 5) {
			value = value.substring(0, 2);
		} else if (value.length >= 4) {
			const mins = parseInt(value.substring(2, 4));
			if (mins > 59) value = value.substring(0, 3);
		}
	}

	formattedValue = value.slice(0, 4).replace(/(\d{2})(\d)/, "$1:$2");
	input.target.value = formattedValue;
	return input;
};

export const formatCNPJInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
	input.target.value = value;
	return input;
};

export const formatCPFInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
	input.target.value = value;
	return input;
};

export const formatCPForCNPJInput = (input) => {
	if (input?.target?.value?.length > 14) {
		return formatCNPJInput(input);
	}
	return formatCPFInput(input);
};

export const formatDataInput = (e) => {
	const value = e.target.value;
	const isValid = moment(value, "YYYY-MM-DD", true).isValid() && value.split("-")[0].length <= 4;
	e.target.value = isValid ? value : moment().format("YYYY-MM-DD");
	return e;
};

export const formatTelefoneInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");
	input.target.value = value;
	return input;
};

export const formatCepInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{5})(\d)/, "$1-$2");
	input.target.value = value;
	return input;
};

export const formatBRLInput = (input) => {
	let value = input.target.value.toString().replace(/[^0-9]/g, "");
	value = Number(value) / 100;
	input.target.value = formatBRL(value);
	return input;
};

export const formatDecimalInput = (input) => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, "")) / 10 ** 2;
	if (isNaN(input.target.value)) input.target.value = 0;

	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "decimal",
		minimumFractionDigits: 2,
	});
	input.target.value = formatter.format(input.target.value);
	return input;
};

export const formatIntegerInput = (input) => {
	if (input.target.value === "" || input.target.value === null) {
		input.target.value = "";
		return input;
	}
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ""));
	return input;
};

export const formatContaBancoInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d*)(\d)/, "$1-$2");
	input.target.value = value;
	return input;
};

export const formatNumeroCartao = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{4})/g, "$1 ");
	value = value.replace(/ $/, "");
	input.target.value = value;
	return input;
};

export const formatCVV = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	input.target.value = value;
	return input;
};

export const formatDataCartaoInput = (input) => {
	let value = input.target.value;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");
	input.target.value = value;
	return input;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf) => {
	if (input.target.value.length > 8) {
		var cep = input.target.value.replace(/[^0-9]/, "");
		const instance = axios.create();

		instance
			.get(`https://viacep.com.br/ws/${cep}/json/`, {})
			.then((res) => {
				setFieldValue(nomeEndereco, res.data.logradouro);
				setFieldValue(nomeBairro, res.data.bairro);
				setFieldValue(nomeCidade, res.data.localidade);
				setFieldValue(nomeUf, res.data.uf);
			})
			.catch(() => {});
	}

	return formatCepInput(input);
};
